var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgIcnAttivit = _ref => {
  let {
    svgRef,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 50.5 50.5",
    fill: "#fff",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M43.3 34.8c1.1 0 2-.9 2-2v-20c0-4.4-3.5-7.9-7.9-7.9h-6.2V2c0-1.1-.9-2-2-2h-7.9c-1.1 0-2 .9-2 2v3h-6.2c-4.4 0-7.9 3.5-7.9 7.9v29.8c0 4.4 3.5 7.9 7.9 7.9h24.2c4.4 0 7.9-3.5 7.9-7.9 0-1.1-.9-2-2-2s-2 .9-2 2c0 2.2-1.8 3.9-3.9 3.9H13.1c-2.2 0-3.9-1.8-3.9-3.9V12.8c0-2.2 1.8-3.9 3.9-3.9h6.2v1c0 3.3 2.7 5.9 6 5.8 3.2 0 5.8-2.6 5.8-5.8v-1h6.2c2.2 0 3.9 1.8 3.9 3.9v20c.1 1.1 1 2 2.1 2zM27.2 9.9c0 1.1-.9 2-2 2s-2-.9-2-2v-6h3.9v6zm8.6 12.5c.9.6 1.1 1.8.5 2.7l-8.8 12.6-.1.1c-.9 1.1-2.2 1.8-3.6 1.9h-.3c-1.3 0-2.6-.5-3.5-1.4l-5.2-5.2c-.8-.8-.8-2 0-2.8.8-.7 2-.8 2.8 0l5.2 5.1c.5.4 1.2.4 1.6-.1l8.7-12.6c.6-.7 1.8-.9 2.7-.3z"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIcnAttivit, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/icn_attività.7b7970ac.svg";
export { ForwardRef as ReactComponent };